const footerSk = {
    "follow_us": "Sledujte nás!",
    "all_rights_reserved": "2024 Code Kitchen Kft všetky práva vyhradené",
    "terms_and_conditions": "Zmluvné podmienky",
    "privacy_policy": "Zásady ochrany osobných údajov"
};

export default footerSk;
